<ng-template #template>
  <div class="container">
    <form [formGroup]="memberForm" (ngSubmit)="onSubmit()">
      <div class="row px-0 py-5" style="min-height: 800px">
        <div class="p-lg-0 col-lg-12">
          <div class="card h-100">
            <div class="card-body table-responsive-md">
              <h3 style="margin-bottom: 0; margin-top: 15px">
                <span>{{ texts.lostPassword }}</span>
              </h3>
              <span *ngIf="errorMessage" style="color: red">
                {{ errorMessage }}
              </span>
              <div class="container row my-4">
                <div class="col-lg-9 col-md-9 col-s-12 col-xs-12">
                  <div class="form-group">
                    <label for="txtUniversityId">{{
                      texts.universityId
                    }}</label>

                    <input
                      type="text"
                      class="form-control"
                      id="txtUniversityId"
                      formControlName="universityId"
                      placeholder="University Id"
                      maxlength="10"
                    />
                  </div>

                  <div class="form-group">
                    <label for="txtEmail">{{ texts.email }}</label>
                    <span
                      *ngIf="
                        (email.dirty || email.touched) &&
                        email.invalid &&
                        email.errors.email
                      "
                      style="color: red"
                    >
                      {{ texts.emailInvalid }}
                    </span>
                    <input
                      type="email"
                      class="form-control"
                      id="txtEmail"
                      formControlName="email"
                      placeholder="Email"
                      maxlength="50"
                    />
                  </div>

                  <a
                    class="btn font-btn-small text-uppercase btn-outline-secondary mr-2 my-2"
                    (click)="cancel()"
                    >{{ texts.cancel }}</a
                  >

                  <button
                    class="btn font-btn-small text-uppercase btn-primary ml-2 my-2"
                    [disabled]="!memberForm.valid"
                    [ngClass]="cssColor + '-inv'"
                    type="submit"
                  >
                    {{ texts.send }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
